<script setup>
import { onMounted, provide, toRef } from 'vue';
import { useValidation, useFormContext } from '/app/composables/form';
import { cn } from '/app/utils/helpers';

defineOptions({ inheritAttrs: false });

const props = defineProps({
    name: { type: String, default: null },
    label: { type: String, default: null },
    hint: { type: String, default: null },
    fieldName: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    forceError: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    modelValue: {
        type: [String, Number, Boolean],
        default: ''
    },
    defaultValue: {
        type: [String, Number, Boolean],
        default: null
    },
    class: {
        type: [String, Array, Object],
        default: ''
    }
});

const emit = defineEmits(['update:modelValue', 'change']);

const form = useFormContext();
const { invalid, error } = useValidation(props);

const busy = form.busy;

function update(value) {
    emit('update:modelValue', value);
    emit('change', value);
}

onMounted(() => {
    // Set default value if modelValue is empty and defaultValue is provided
    if ((!props.modelValue || props.modelValue === '') && props.defaultValue !== null) {
        update(props.defaultValue);
    }
});

provide('radioGroup', {
    name: toRef(props, 'name'),
    modelValue: toRef(props, 'modelValue'),
    busy,
    update,
});
</script>

<template>
    <div :class="cn(invalid && 'is-error', $props.class)">
        <span v-if="label" class="form-group__label" style="display: block;">{{ label }}</span>
        <span v-if="hint" class="form-group__hint" style="display: block;">{{ hint }}</span>
        <slot></slot>
        <span v-if="invalid" class="form-group__error">{{ error }}</span>
    </div>
</template>
